import { Image, PageWidget } from 'app/src/shared/components'
import { useWebAppContext } from 'app/src/shared/hooks'
import { useEffect, type ReactElement } from 'react'

import welfareForbidden from 'app/static/images/welfare_forbidden.png'
import { Button } from 'primereact/button'
import { useTranslation } from 'react-i18next'

export function UserForbidden(): ReactElement {
  const context = useWebAppContext()

  const { t } = useTranslation('errors')

  useEffect(() => {
    context.update({ breadCrumbItems: [] })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <PageWidget containerClassNamesOverrides='mb-1'>
        <div className='flex justify-center'>
          <Image src={welfareForbidden} alt={'Accesso negato'} />
        </div>
        <h1 className='mb-4 mt-8 text-center text-3xl font-bold'>{t('UserForbiddenTitle')}</h1>
        <p>
          {t('UserForbiddenMsgPrefix')}
          <Button
            link
            label={'backofficewelfare@postewelfareservizi.it'}
            iconPos='left'
            className='custom-focus break-alltext-left p-0 px-1'
            onClick={() => (window.location.href = 'mailto:backofficewelfare@postewelfareservizi.it')}
          />
          {t('UserForbiddenMsgPostfix')}
        </p>
      </PageWidget>
    </>
  )
}
